import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import {
  CreateAgencyCommand,
  GetAgenciesCommand,
  GetAgencyByIdCommand,
  UpdateAgencyCommand,
} from './agency.commands';
import {
  CreatedAgencyEvent,
  GottenAgenciesEvent,
  GottenAgencyEvent,
  UpdatedAgencyEvent,
} from './agency.events';
import { isCode } from '../../../shared/helpers/transaction.helpers';

@Injectable()
export class AgencyEffects {
  prefix = 'agency';
  createAgencyCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateAgencyCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAgenciesCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAgencyByIdCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createAgencyCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: CreateAgencyCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, CreatedAgencyEvent)) {
          response.push(
            CreatedAgencyEvent({
              agency: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.updateAgencyCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: UpdateAgencyCommand,
      prefix: this.prefix,

      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, UpdatedAgencyEvent)) {
          response.push(
            UpdatedAgencyEvent({
              agency: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.getAgenciesCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: GetAgenciesCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, GottenAgenciesEvent)) {
          response.push(
            GottenAgenciesEvent({
              agencies: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.getAgencyByIdCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: GetAgencyByIdCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, GottenAgencyEvent)) {
          response.push(
            GottenAgencyEvent({
              agency: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
  }
}
